import React, { useRef, useState } from 'react'

import { ArrowUturnLeftIcon } from '@heroicons/react/24/outline'

import { Bubble } from './Bubble'
import { Replies } from './Replies'
import { MessageComposerDnD } from './components/MessageComposerDnD'
import { useAppSelector } from '@/client/hooks'
import { useCreateStreamingNoteMutation } from '@/services/streamingNote'
import { systemUsers } from '@/utils/user'

export default function ParentMessage({ message, applicationExternalId }) {
  const [isRepliesOpen, setIsRepliesOpen] = useState(true)
  const [replyToStreamingNote, { isLoading }] = useCreateStreamingNoteMutation()
  const [showComposer, setShowComposer] = useState(false)
  const bubbleWrapperEl = useRef(null)
  const shouldHideSystemMessage = useAppSelector((state) => state.general.hideSystemMessages)

  const handleUpdateComposer = () => {
    setTimeout(() => {
      bubbleWrapperEl.current.querySelector('.public-DraftEditor-content')?.click()
    }, 100)
  }

  if (shouldHideSystemMessage && systemUsers.includes(message.user?.user?.email)) {
    return null
  }

  return (
    <div
      key={message.uuid}
      className='mb-3'
      ref={bubbleWrapperEl}
    >
      <Bubble
        message={message}
        setShowComposer={setShowComposer}
        showComposer={handleUpdateComposer}
        setIsRepliesOpen={setIsRepliesOpen}
        isRepliesOpen={isRepliesOpen}
        hasReplies={message.child_streaming_notes?.length > 0}
      />

      {message.child_streaming_notes?.length > 0 && (
        <Replies
          messages={message.child_streaming_notes}
          isRepliesOpen={isRepliesOpen}
          setIsRepliesOpen={setIsRepliesOpen}
          setShowComposer={setShowComposer}
          showComposer={handleUpdateComposer}
        />
      )}

      <div className='relative pl-3 ml-6 border-transparent'>
        {showComposer && (
          <div className='mt-3'>
            <MessageComposerDnD
              parentStreamingNoteId={message.id}
              applicationId={message.application}
              applicationExternalId={applicationExternalId}
              createStreamingNote={replyToStreamingNote}
              isCreatingStreamingNote={isLoading}
              placeholder='Reply to this message...'
            />
            <div className='mx-3 mt-1 flex justify-end'>
              <button
                type='button'
                className='text-sm text-gray-400 hover:text-gray-900'
                onClick={() => {
                  setShowComposer(!showComposer)
                  handleUpdateComposer()
                }}
              >
                {showComposer && <span>Dismiss</span>}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
